"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "calosso": {
    "12727f4d": [{
      "hkey": "fd1d4fe5",
      "slug": "calosso",
      "name": "Calosso",
      "primary": true,
      "skipSearch": false
    }],
    "castagna": [{
      "hkey": "fd1d4fe5",
      "slug": "calosso",
      "name": "Calosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c854464e": [{
      "hkey": "fd1d4fe5",
      "slug": "calosso",
      "name": "Calosso",
      "primary": true,
      "skipSearch": false
    }],
    "mosiano": [{
      "hkey": "fd1d4fe5",
      "slug": "calosso",
      "name": "Calosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d8cbaaa5": [{
      "hkey": "fd1d4fe5",
      "slug": "calosso",
      "name": "Calosso",
      "primary": true,
      "skipSearch": false
    }],
    "regione-rodotiglia": [{
      "hkey": "fd1d4fe5",
      "slug": "calosso",
      "name": "Calosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;